export default __webpack_public_path__ + "static/pilot-CJ-69322a137360c95cac964f4abb57c600.png";